import LXSelector from './lxSelector';

interface LXPlainSelectorProps {
  value: plain;
  onSelect: (plain: any) => void;
}

const LXPlainSelector = (props: LXPlainSelectorProps) => {
  return (
    <LXSelector<plain>
      dropdownHeaderWidth={100}
      dropdownItemWidth={160}
      value={props?.value}
      values={[true, false]}
      labels={['true', 'false']}
      onSelect={props.onSelect}
    ></LXSelector>
  );
};

export default LXPlainSelector;
